// extracted by mini-css-extract-plugin
export default {"CountAndExperi":"CountAndExperi_CountAndExperi__Nvlrc","statItem":"CountAndExperi_statItem__sxzLD","text":"CountAndExperi_text__7sIwg"};